import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  fathomService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface FathomPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function FathomPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: FathomPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="fathom"
      displayName="Fathom"
      description="Connect your Fathom account to access your meeting recordings, transcripts, and summaries directly in conversations."
      features={[
        'Search your meeting recordings',
        'Pull up transcripts from past meetings',
        'Surface action items and key decisions',
        'AI-powered meeting summaries',
      ]}
      accentColor="violet"
      events={{
        modalOpened: OnboardingEvents.FATHOM_MODAL_OPENED,
        oauthStarted: OnboardingEvents.FATHOM_OAUTH_STARTED,
        connected: OnboardingEvents.FATHOM_CONNECTED,
        connectionFailed: OnboardingEvents.FATHOM_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.FATHOM_MODAL_CLOSED,
      }}
      service={fathomService}
    />
  );
}
